import { render, staticRenderFns } from "./manage-materials.vue?vue&type=template&id=07ce4cda&scoped=true"
import script from "./manage-materials.vue?vue&type=script&lang=js"
export * from "./manage-materials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ce4cda",
  null
  
)

export default component.exports